/*
 Copyright (c), CKSource Holding sp. z o.o. All rights reserved.
 */

import Message, { IMessage } from './../../message';
import { IDescriptorBody } from '../../descriptor';
import { ISocket } from '../sessioncollection';

export interface ISessionsConnectResponse extends IMessage {
	channel: string;
	sockets: {
		user?: string;
		session: string;
		role?: string;
		permissions?: string[];
	}[];
}

export default class SessionsConnectResponse extends Message {
	public static readonly DESCRIPTOR_NAME: string = 'SessionsConnectResponse';

	public static readonly DESCRIPTOR: IDescriptorBody = {
		fields: {
			channel: {
				type: 'string',
				id: 1
			},
			sockets: {
				rule: 'repeated',
				type: 'SessionsSocketDescriptor',
				id: 2
			}
		}
	};

	public constructor( public readonly channel: string, public readonly sockets: ISocket[] = [] ) {
		super();
	}

	public toJSON(): ISessionsConnectResponse {
		return {
			channel: this.channel,
			sockets: this.sockets.map( socket => ( {
				user: socket.userId,
				session: socket.id,
				role: socket.role,
				permissions: socket.permissions
			} ) )
		};
	}

	public static fromJSON( data: ISessionsConnectResponse ): SessionsConnectResponse {
		return new SessionsConnectResponse(
			data.channel,
			data.sockets.map( socket => ( {
				id: socket.session,
				userId: socket.user,
				role: socket.role,
				permissions: socket.permissions
			} ) )
		);
	}
}
